














































































































































































































import { Component, Vue } from 'vue-property-decorator'

@Component({
  props: {},
  components: {}
})
export default class MainFooter extends Vue {
  // data
  message = 'Hello'

  // computed
  get reverseMessage() {
    return this.message
      .split('')
      .reverse()
      .join('')
  }

  // method
  changeMessage() {
    this.message = 'Good bye'
  }

  // Lifecycle hooks
  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
